document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const target = e.target.closest('.facets__item label, .bundle-filter-button, .category-chip, .clear-all, .remove-chip');
    if (target) {
      console.log(target + " is my target");
      handleClick(e);
    }
  });

  document.addEventListener('change', function (e) {
    const target = e.target;
    if (
      target.matches('.facets__form input[type="checkbox"]') ||
      target.matches('.facets__form input[type="radio"]') ||
      target.matches('.facets__form input[name="filter.v.price.gte"]') ||
      target.matches('.facets__form input[name="filter.v.price.lte"]')
    ) {
      handleChange(e);
    }
  });

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log("function calling ")

    const target = e.target.closest('.facets__item label, .bundle-filter-button, .category-chip, .clear-all, .remove-chip');
    let searchParams = new URLSearchParams(window.location.search);
    let filterName, filterValue;

    if (target.classList.contains('bundle-filter-button') || target.tagName === 'LABEL') {
      const checkbox = target.querySelector('input[type="checkbox"]');
      const radio = target.querySelector('input[type="radio"]');
      const input = checkbox || radio;

      if (input) {
        const wasChecked = input.checked;
        if (input.type === 'checkbox') {
          input.checked = !input.checked;
          if (target.classList.contains('bundle-filter-button')) {
            target.classList.toggle('active', input.checked);
            target.style.display = 'none';
            target.offsetHeight;
            target.style.display = '';
          }
        } else if (input.type === 'radio') {
          document.querySelectorAll(`input[name="${input.name}"]`).forEach(r => r.checked = false);
          input.checked = true;
        }

        const form = input.closest('form');
        if (form) {
          if (input.type === 'checkbox' && wasChecked && !input.checked) {
            console.log('Removing unchecked filter:', input.name, input.value);
            const allMatchingInputs = document.querySelectorAll(`input[type="checkbox"][name="${input.name}"][value="${input.value}"]`);
            allMatchingInputs.forEach(matchingInput => {
              matchingInput.checked = false;
            });
            const values = searchParams.getAll(input.name).filter(v => v !== input.value);
            searchParams.delete(input.name);
            values.forEach(v => searchParams.append(input.name, v));
          } else {
            const formData = new FormData(form);
            const tempParams = new URLSearchParams(formData);
            
            tempParams.forEach((value, key) => {
              if (input.type === 'radio' && key === input.name) {
                searchParams.set(key, value);
              } else {
                if (!searchParams.getAll(key).includes(value)) {
                  searchParams.append(key, value);
                }
              }
            });
          }
          if (!(input.type === 'checkbox' && wasChecked && !input.checked)) {
            const otherForms = document.querySelectorAll('facet-filters-form form:not(#' + form.id + ')');
            otherForms.forEach((otherForm) => {
              const otherFormData = new FormData(otherForm);
              otherFormData.forEach((value, key) => {
                if (key !== input.name || input.type !== 'radio') {
                  if (!searchParams.getAll(key).includes(value)) {
                    searchParams.append(key, value);
                  }
                }
              });
            });
          }

          filterName = input.name;
          filterValue = input.type === 'radio' ? input.value : searchParams.getAll(input.name).join(', ');
          pushFilterByEvent(input.id.split('-')[1] || input.name, filterValue);
        }
      }
    } else if (target.classList.contains('category-chip') || target.classList.contains('clear-all') || target.classList.contains('remove-chip')) {
      
      if (target.classList.contains('clear-all')) {
        const excludedKeys = new Set(['filter.v.price.gte', 'filter.v.price.lte', 'sort_by']);
        searchParams = new URLSearchParams();
        excludedKeys.forEach(key => {
          const value = new URLSearchParams(window.location.search).get(key);
          if (value) searchParams.set(key, value);
        });
        filterName = 'Clear All';
        filterValue = '';
      } else if (target.classList.contains('remove-chip')) {
        // Get the filter data from the remove chip's href attribute
        let removedKey, removedValue;
        
        console.log("Processing remove chip:", target);
        
        // The remove chip has an href attribute like: "{{ value.url_to_remove }}"
        const chipUrl = target.getAttribute('href');
        console.log("Remove chip URL:", chipUrl);
        
        if (chipUrl) {
          // Parse the current URL parameters
          const currentParams = new URLSearchParams(window.location.search);
          console.log("Current params:", currentParams.toString());
          
          // Parse the remove URL parameters  
          let removeParams;
          if (chipUrl.includes('?')) {
            removeParams = new URLSearchParams(chipUrl.split('?')[1]);
          } else {
            // If it's a relative URL, parse it differently
            const tempUrl = new URL(chipUrl, window.location.origin);
            removeParams = new URLSearchParams(tempUrl.search);
          }
          console.log("Remove URL params:", removeParams.toString());
          
          // Find which parameter is being removed by comparing current vs remove URL
          for (const [key] of currentParams) {
            const currentValues = currentParams.getAll(key);
            const removeValues = removeParams.getAll(key);
            
            // Find the value that exists in current but not in remove
            const removedValues = currentValues.filter(val => !removeValues.includes(val));
            
            if (removedValues.length > 0) {
              removedKey = key;
              removedValue = removedValues[0]; // Take the first removed value
              console.log("Identified removed filter:", removedKey, "=", removedValue);
              break;
            }
          }
          
          // Alternative method: look for keys that exist in current but not in remove
          if (!removedKey) {
            for (const [key] of currentParams) {
              if (!removeParams.has(key)) {
                removedKey = key;
                removedValue = currentParams.get(key);
                console.log("Found completely removed key:", removedKey, "=", removedValue);
                break;
              }
            }
          }
          
          // If we still haven't found it, use the remove URL directly
          if (!removedKey && chipUrl) {
            console.log("Using remove URL directly to set search params");
            const removeUrl = new URL(chipUrl, window.location.origin);
            searchParams = new URLSearchParams(removeUrl.search);
          }
        }
        
        console.log("Final removal:", { removedKey, removedValue });        
        if (removedKey && removedValue) {
          // Remove the specific filter value from search params
          const currentValues = searchParams.getAll(removedKey);
          const filteredValues = currentValues.filter(v => v !== removedValue);
          
          // Clear the key and re-add remaining values
          searchParams.delete(removedKey);
          filteredValues.forEach(v => searchParams.append(removedKey, v));
          
          // Update corresponding form inputs
          const relatedInputs = document.querySelectorAll(`input[name="${removedKey}"][value="${removedValue}"]`);
          relatedInputs.forEach(input => {
            if (input.type === 'checkbox') {
              input.checked = false;
            }
          });
          
          filterName = removedKey;
          filterValue = removedValue;
          
          console.log("Successfully prepared filter removal:", removedKey, "=", removedValue);
        } else if (chipUrl) {
          // Fallback: use the remove URL directly
          const removeUrl = new URL(chipUrl, window.location.origin);
          searchParams = new URLSearchParams(removeUrl.search);
          filterName = 'Remove Filter';
          filterValue = 'via URL';
          console.log("Using remove URL directly");
        } else {
          console.error('Could not determine filter to remove from chip');
        }
      }else if (target.classList.contains('category-chip')) {
        const filterType = "category_product";
        const filterValue = target.dataset.category;
        
        pushFilterByEvent(filterType, filterValue);
  let chipUrl = target.getAttribute('href');
  if (chipUrl && chipUrl.includes('?')) {
    const chipParams = new URLSearchParams(chipUrl.split('?')[1]);
    console.log("Adding category chip params:", chipParams.toString());

    // Optionally clear existing category filters
    searchParams.delete('filter.category');

    // Preserve other form filters
    const allForms = document.querySelectorAll('facet-filters-form form');
    allForms.forEach((form) => {
      const formData = new FormData(form);
      formData.forEach((value, key) => {
        if (!searchParams.getAll(key).includes(value)) {
          searchParams.append(key, value);
        }
      });
    });

    // Add new category chip parameters
    chipParams.forEach((value, key) => {
      if (!searchParams.getAll(key).includes(value)) {
        searchParams.append(key, value);
      }
    });

    filterName = 'Quick Filter';
    filterValue = Array.from(new Set(chipParams.values())).join(', ');
  }
}
    }

    if (filterName=='Quick Filter' && filterValue !== undefined) {
      pushFilterByEvent(filterName, filterValue);
    }

    console.log('handleClick searchParams:', searchParams.toString());
    FacetFiltersForm.renderPage(searchParams.toString(), e, true).then(() => {
      document.dispatchEvent(new CustomEvent('facet:update'));
    });
  }

  function handleChange(e) {
    e.preventDefault();
    e.stopPropagation();

    const input = e.target;
    if (
      input.matches('.facets__form input[type="checkbox"]') ||
      input.matches('.facets__form input[type="radio"]') ||
      input.matches('.facets__form input[name="filter.v.price.gte"]') ||
      input.matches('.facets__form input[name="filter.v.price.lte"]')
    ) {
      const form = input.closest('form');
      if (form) {
        let searchParams = new URLSearchParams(window.location.search);
        const formData = new FormData(form);
        const tempParams = new URLSearchParams(formData);

        tempParams.forEach((value, key) => {
          if (
            (input.type === 'radio' && key === input.name) ||
            key === 'filter.v.price.gte' ||
            key === 'filter.v.price.lte'
          ) {
            searchParams.set(key, value);
          } else if (!input.checked && key === input.name && input.value === value) {
            const values = searchParams.getAll(key).filter(v => v !== value);
            searchParams.delete(key);
            values.forEach(v => searchParams.append(key, v));
            if (searchParams.getAll(key).length === 0) {
              searchParams.delete(key);
            }
          } else {
            if (!searchParams.getAll(key).includes(value)) {
              searchParams.append(key, value);
            }
          }
        });

        const otherForms = document.querySelectorAll('facet-filters-form form:not(#' + form.id + ')');
        otherForms.forEach((otherForm) => {
          const otherFormData = new FormData(otherForm);
          otherFormData.forEach((value, key) => {
            if (key !== input.name || input.type !== 'radio') {
              if (!searchParams.getAll(key).includes(value)) {
                searchParams.append(key, value);
              }
            }
          });
        });

        console.log('handleChange searchParams:', searchParams.toString());
        FacetFiltersForm.renderPage(searchParams.toString(), e, true).then(() => {
          document.dispatchEvent(new CustomEvent('facet:update'));
        });
      } else {
        console.error('No form found for input:', input);
      }
    }
  }

  // Synchronize sort_by radio buttons across forms
  document.addEventListener('change', function (e) {
    const target = e.target;
    if (target.matches('.facets__form input[type="radio"][name="sort_by"]')) {
      const value = target.value;
      document.querySelectorAll('.facets__form input[type="radio"][name="sort_by"]').forEach(radio => {
        radio.checked = radio.value === value;
      });
      console.log('Synchronized sort_by:', value);
    }
  });
});
